import Immutable from 'immutable';
import LocationsConstants from 'app/constants/LocationsConstants';
import EventsConstants from 'app/constants/EventsConstants';

const initialState = Immutable.fromJS({
  results: [],
  distances: {},
  nearPoint: null,
  query: {},
  isFetching: false,
  eventsLibraryInfo: null,
  googleMapsApiKey: null
});

export default function locationsSearch(state = initialState, action) {
  switch (action.type) {
    case LocationsConstants.SEARCH_LOCATIONS_REQUEST: {
      return state.merge({
        isFetching: true
      });
    }

    case LocationsConstants.SEARCH_LOCATIONS_SUCCESS: {
      const { results, distances, nearPoint, eventsLibraryInfo } = action.payload.locations;
      return state.merge({
        results: Immutable.fromJS(results),
        distances: Immutable.fromJS(distances),
        nearPoint: Immutable.fromJS(nearPoint),
        query: Immutable.fromJS(action.query),
        isFetching: false,
        eventsLibraryInfo: Immutable.fromJS(eventsLibraryInfo)
      });
    }

    case LocationsConstants.SEARCH_LOCATIONS_FAILURE: {
      return initialState;
    }

    case EventsConstants.EVENTS_SETTINGS_SUCCESS: {
      return state.merge({
        googleMapsApiKey: action.payload.libraryInfo.googleMapsOptions.apiKey
      });
    }

    default:
      return state;
  }
}
